/* トップのファーストビュー Souhuka スライドの動き（2026-10-16）
   - スライドが表示されるたびに、画面写真の上に重ねた数字（先週比・今週の総負荷量）を 0 から数え上げる
   - 見出し・ボタン・スマホの出方、グラフの描画、光の筋は CSS（assets/fp-hero2.css の fp__slide--sk）
   - ファーストビューが画面外のときは .is-off を付けて、くり返しの動きを止める
   - 動きを減らす設定の人には何もしない（HTML に最終の数字が書いてある） */
(function (root) {
  'use strict';

  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function at(t, target) {
    if (t <= 0) return 0;
    if (t >= 1) return target;
    return target * ease(t);
  }
  function format(v, opt) {
    opt = opt || {};
    var dec = opt.dec || 0;
    var s = (Math.round(v * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    s = parts.join('.');
    return (opt.plus ? '+' : '') + s;
  }
  root.fpSkCount = { ease: ease, at: at, format: format };

  var doc = root.document;
  if (!doc || !doc.getElementById) return;
  var hero = doc.getElementById('fpHero');
  if (!hero || !hero.querySelector) return;
  var slide = hero.querySelector('.fp__slide--sk');
  if (!slide) return;
  var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  var nums = slide.querySelectorAll('[data-sk-count]');
  var raf = 0, visible = true;

  function run() {
    if (raf) cancelAnimationFrame(raf);
    var t0 = performance.now();
    var items = [];
    for (var k = 0; k < nums.length; k++) {
      var el = nums[k];
      items.push({
        el: el,
        target: parseFloat(el.getAttribute('data-sk-count')),
        dec: parseInt(el.getAttribute('data-sk-dec') || '0', 10),
        plus: el.hasAttribute('data-sk-plus'),
        delay: parseInt(el.getAttribute('data-sk-delay') || '0', 10),
        dur: parseInt(el.getAttribute('data-sk-dur') || '1100', 10)
      });
      el.textContent = format(0, { dec: items[k].dec, plus: items[k].plus });
    }
    function frame(now) {
      var done = true;
      for (var k = 0; k < items.length; k++) {
        var it = items[k];
        var t = (now - t0 - it.delay) / it.dur;
        if (t < 1) done = false;
        it.el.textContent = format(at(t, it.target), it);
      }
      raf = done ? 0 : requestAnimationFrame(frame);
    }
    raf = requestAnimationFrame(frame);
  }
  function finish() {
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
    for (var k = 0; k < nums.length; k++) {
      var el = nums[k];
      el.textContent = format(parseFloat(el.getAttribute('data-sk-count')), {
        dec: parseInt(el.getAttribute('data-sk-dec') || '0', 10), plus: el.hasAttribute('data-sk-plus')
      });
    }
  }

  var wasActive = slide.getAttribute('data-active') === 'true';
  if (root.MutationObserver) {
    new MutationObserver(function () {
      var active = slide.getAttribute('data-active') === 'true';
      if (active && !wasActive && visible) run();
      if (!active && wasActive) finish();
      wasActive = active;
    }).observe(slide, { attributes: true, attributeFilter: ['data-active'] });
  }
  if (root.IntersectionObserver) {
    new IntersectionObserver(function (es) {
      visible = es[es.length - 1].isIntersecting;
      slide.classList.toggle('is-off', !visible);
    }).observe(hero);
  }
})(typeof window !== 'undefined' ? window : this);
